module.exports = "label{width:calc(8px * 24)}@media screen and (max-width: 576px){label,input{width:100%}}\n"